<app-menu-toggle
  tooltip="Event data collections info"
  icon="info"
  [active]="showObjectsInfo"
  (click)="toggleOverlay()"
>
</app-menu-toggle>
